import { render, staticRenderFns } from "./TagsSettings.vue?vue&type=template&id=1b2240d4&scoped=true&"
import script from "./TagsSettings.vue?vue&type=script&lang=js&"
export * from "./TagsSettings.vue?vue&type=script&lang=js&"
import style0 from "./TagsSettings.vue?vue&type=style&index=0&id=1b2240d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2240d4",
  null
  
)

export default component.exports